import { Dropdown as NeetoUIDropdown } from "neetoui";

import ProductSwitcherMenu from "./Menu";
import MenuItemButton from "./MenuButton";

const { Menu, MenuItem } = NeetoUIDropdown;

const Dropdown = () => (
  <NeetoUIDropdown
    appendTo="parent"
    className="neeto-molecules-product-switcher-menu-popup-wrapper"
    closeOnSelect={false}
    customTarget={<MenuItemButton />}
    interactiveDebounce={30}
    offset={[0, 5]}
    position="right"
    trigger="all"
    zIndex={99999}
    dropdownProps={{
      classNames: "neeto-molecules-product-switcher-menu-popup__dropdown",
    }}
  >
    <Menu>
      <MenuItem>
        <ProductSwitcherMenu />
      </MenuItem>
    </Menu>
  </NeetoUIDropdown>
);

export default Dropdown;
